<template>

  <div class="container">
    <table id="cart" class="table table-hover table-condensed">
      <thead>
        <tr style="color:black">
          <th style="width:50%">Product</th>
          <th style="width:10%">Price</th>
          <th style="width:8%">Quantity</th>
          <th style="width:22%" class="text-center">Subtotal</th>
          <th style="width:10%"></th>
        </tr>
      </thead>

      <tbody>
          <!--<tr v-for="(cartItem, index) in products" :key="cartItem['item.name']">-->
          <tr v-for="(cartItem, index) in cartItemList">
              <td style="width:50%">
                <p style="font-family:georgia,garamond,serif;color:blue;font-size:16px">{{cartItem.item.name}}</p>
              </td>  
              <td style="width:10%">
                <p style="font-family:georgia,garamond,serif;color:blue;font-size:16px">{{cartItem.item.price}}</p>
              </td> 
              <td style="width:8%">
                <p style="font-family:georgia,garamond,serif;color:blue;font-size:16px">{{cartItem.quantity}}</p>
              </td>
              <td style="width:22%" class="text-center">
                <!--<p style="font-family:georgia,garamond,serif;color:blue;font-size:16px" :class="[calsubtotal(cartItem.quantity,cartItem.item.price)]">{{subtotal}}</p>-->
                <!--<b-col sm="12">-->
                  <b-form-input 
                    :value="(cartItem.quantity * cartItem.item.price) || 0" 
                    type="text" readonly style="font-family:georgia,garamond,serif;color:blue;font-size:16px;text-align:right"/>
                <!--</b-col>-->
              </td>
              <td style="width:10%" class="actions" data-th="">
                <button class="btn btn-danger btn-sm" @click="removeItem(cartItem)"><i class="fa fa-trash-alt"></i></button>								
              </td>
              
          </tr>
      </tbody>

      <tfoot style="color:black">
          <td>
            <!--<button class="btn btn-warning" @click="saveShoppingCartLocal">
              <i class="fas fa-shopping-cart"></i> Continue Shopping
            </button>-->
            <router-link :to="{ name: 'Product', params: { category: 'vit' } }">
              <button class="btn btn-warning">
                <i class="fas fa-shopping-cart"></i> Continue Shopping
              </button>
            </router-link>
          </td>
          <td colspan="2" class="hidden-xs"></td>
          <td class="hidden-xs text-center"><strong>Total $ {{cartTotal}} </strong></td>
          <td>
           <router-link to="/contact">
            <button class="btn btn-success btn-block" @click="checkout"> 
                Checkout <i class="fa fa-angle-right"></i>
              </button>
           </router-link>
          </td>
        </tr>
      </tfoot>

    </table>
  </div>
  
</template>

<script>
/*eslint-disable*/
import {
  mapActions,
  mapGetters
} from 'vuex';

export default {
  name: 'cartitem',
  data: () => ({
    subtotal:0,
    cartvalue:0
  }),
  
  methods:{
   calsubtotal(a,b){
     if(!isNaN(a) && a.length != 0 && !isNaN(b) && b.length != 0) {
        this.subtotal = parseFloat(a).toFixed(2) * parseFloat(b).toFixed(2)
     }
     if(!isNaN(this.subtotal) && this.subtotal.length != 0) {
        this.cartvalue += this.subtotal
     }  
    },
  saveShoppingCartLocal() {
      //this.$router.push('/product') 
    },
  removeItem(cartItem){
      this.$store.dispatch("REMOVE_ITEM",cartItem); 
  },
  checkout(){
    this.$store.dispatch("GET_ITEM_DESCR"); 
    //this.$router.push('/contact') //this will bypass the require login machanism. need to comment it.
  }
 },

 computed: {
   ...mapGetters(['cartItemList']),
   /*products() {
      return this.$store.getters.cartItemList;
     },*/
     cartTotal() {
       //alert(this.$store.getters.cartTotal)
       return this.$store.getters.cartTotal;
     }
  },

  created () {
  }

}
</script>

<style scoped>
  .list-shopping-cart-leave-active {
    transition: all 0.4s;
  }

  .list-shopping-cart-leave-to {
    opacity: 0;
    transform: translateX(50px);
  }

</style>



// WEBPACK FOOTER //
// src/components/cartitem.vue